import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from 'src/app/providers/general/general.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { Observable } from 'rxjs';
import { Application } from '../../models/header/application.interface';
import { select, Store } from '@ngrx/store';
import { AppMenu, GetUserApplications } from 'src/app/state/userMap.reducer';
import { Menu } from '../../models/sidebar/sidebar.interface';
import { isQuickLinks, LoadRoleMenus } from 'src/app/state/userMap.action';
import { EmployeeService } from 'src/app/providers/employee/employee.service';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KudosService } from 'src/app/providers/kudos/kudos.service';
//import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { SidebarService } from 'src/app/providers/sidebar/sidebar.service';
import Swal from 'sweetalert2';
import { LangService } from 'src/app/providers/lang/lang.service';

declare let $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  entity: any;
  applications$: Observable<Application[]>;
  public public = environment.base_path;
  public appUrl = environment.app_url;
  menus$: Observable<Menu[]>;
  public userName = localStorage.getItem('user_name');
  public userId = localStorage.getItem('user');
  public uId = localStorage.getItem('auth-token');
  public res = this.uId.split('-');

  language: string;
  lng: ['en', 'hi'];
  resultTemp: any = [];
  empDetail: any;
  myAddress: any;
  myContact: any;
  myFinance: any;
  myEduc: any;
  myFam: any;
  myExp: any;
  Logs: any;
  result: any = [];
  languageList: any = [];
  ipAddress: any;
  sosForm: FormGroup;
  empImage: any;
  submit = false;
  allowPopup: any = '';
  allowLang = false;
  crntLang = '';
  observable$: Observable<boolean>;
  empStatus:any;
  isPlacement:any;
  resultPlacement: any = [];
  ccId: any;
  rmUserId: any;
  rmName: any;
  empPhone: any;
  empEmail: any;
  empName: any;

  constructor(
    private router: Router,
    private http: GeneralService,
    private httpC: HttpClient,
    private empService: EmployeeService,
    public translate: TranslateService,
    private spinner: SpinnerVisibilityService,
    private authService: AuthService,
    private notifyService: NotificationService,
    private store: Store,
    private formBuilder: FormBuilder,
    private kudosServe: KudosService,
    public sideSrv: SidebarService
  ) {
    this.applications$ = this.store.pipe(select(GetUserApplications));

    this.http.showLang.subscribe((res) => {
      this.allowLang = res;
    });

    this.http.crntLanguage.subscribe((res) => {
      if (res && this.crntLang == '') {
        this.languageGet();
      }
    });
  }

  ngOnInit(): void {
    this.getLoggedInEmpDetails();
    this.languageGet();
    this.sosFormField();
    this.entity = localStorage.getItem('entity');

    setTimeout(() => {
      // window.close();
      this.allowPopup = window.open(environment.apiUrl + 'loading');
      if (this.allowPopup == null) {
        Swal.fire('Warning', 'Please allow popups before login', 'error');
      } else {
        this.allowPopup.close();
      }
    }, 1000);

      this.empService.userTypeGet().subscribe(res => {
      this.resultPlacement = res;
      this.isPlacement = this.resultPlacement.isPlacement;
      },err => {});
  }

  languageGet(): void {
    this.http.getLanguage().subscribe((res) => {
      this.languageList = res.data;
      const lng = localStorage.getItem('so_lang');
      const labl = this.languageList.filter((val) => val.value == lng);
      if (labl.length > 0) {
        this.crntLang = labl[0].label;
      } else {
        this.crntLang = '';
      }
    });
  }

  sosFormField(): void {
    this.sosForm = this.formBuilder.group({
      sos_contact_no: ['', Validators.required],
    });
  }
  goToQuery(url): void {
    let portal_url = environment.app_urlsdx;
    console.log('origin', document.location.origin);
    console.log('portal_url', portal_url);
    if (portal_url != document.location.origin) {
      let appLink = url; //'/queries/create';
      this.authService.appLogin(appLink).subscribe(
        (res) => {
          console.log(portal_url + '/#/auth/app-login/' + res.data);
          window.open(portal_url + '/#/auth/app-login/' + res.data, '_self');
        },
        (err) => {
          this.notifyService.showError('Something Went Wrong');
        }
      );
    } else {
      // this.router.navigateByUrl('/queries/create');
      this.router.navigateByUrl(url);
    }
  }
  switchLang(lang): void {
    this.crntLang = lang.label;
    localStorage.setItem('so_lang', lang.value);
    this.translate.use(localStorage.getItem('so_lang') + '_lang');
    this.http.crntLanguage.next(lang.value);
  }

  toggleSidebar = () => {
    if ($('body').hasClass('mini-sidebar')) {
      $('body').removeClass('mini-sidebar');
      localStorage.setItem('mini-sidebar', '0');
      $('.subdrop + ul').slideDown();
    } else {
      $('body').addClass('mini-sidebar');
      localStorage.setItem('mini-sidebar', '1');
      $('.subdrop + ul').slideUp();
    }
  };

  logout(): void {
    const params = {
      ip: this.ipAddress,
      source: 'web',
    };
    console.log('pp', params);
    const popUp = localStorage.getItem('popUp');
    const date = localStorage.getItem('date');
    const usrId = localStorage.getItem('usrId');
    const ballon = localStorage.getItem('showBallon');
    const evntDate = localStorage.getItem('eventDate');

    this.authService.logOut(params).subscribe(
      (res) => {
        this.result = res;
        // if (this.result.status) {
        // this.store.dispatch(LoggedOutUserSuccess());

        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        // this.router.navigate(['/']);
        // tslint:disable-next-line: no-debugger
        window.location.href = environment.app_url;
        window.location.reload();
        this.notifyService.showSuccess(this.result.msg, 'Success');
        // }
      },
      (err) => {
        // this.store.dispatch(LoggedOutUserSuccess());
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('', ballon);
        localStorage.setItem('eventDate', evntDate);

        // this.router.navigate(['/']);
        // tslint:disable-next-line: no-debugger
        window.location.href = environment.app_url;
        window.location.reload();
        this.notifyService.showSuccess(this.result.msg, 'Success');
      }
    );
  }
  clickMyProfile(): void {
    this.res[1] = this.res[1].trim();
    // console.log(this.res[1]);
    // console.log(this.userId);
    // return;
    if(this.empStatus=='1')
    {
    this.router.navigate(['/quick-links/my-profile/' + this.userId]);
    }
    else
    {
      this.router.navigate(['/alumni/my-profile/' + this.userId]);
    }
    this.getEmployeeDetail();
  }
  getEmployeeDetail(): void {
    const temp = {
      user_id: this.userId,
    };
    this.empService.getEmployeesDetails(temp).subscribe(
      (res) => {
        this.resultTemp = res;
        this.empDetail = this.resultTemp.data.det;
        // this.myAddress = this.resultTemp.data.address;
        // this.myContact = this.resultTemp.data.contacts;
        // this.myFinance = this.resultTemp.data.finance;
        // this.myEduc = this.resultTemp.data.educ;
        // this.myFam = this.resultTemp.data.fam;
        // this.myExp = this.resultTemp.data.exp;
        this.Logs = this.resultTemp.data.syslogs;
        console.log('logs', this.Logs);
        // this.txnID = this.empDetail.user_id;
      },
      (err) => {}
    );
  }

  getLoggedInEmpDetails(): void {
    this.empService.getLoggedInEmpDetails().subscribe((res: any) => {
      console.log(res);
      if (res.status) {
        this.empName = res.data.emp_name;
        this.empEmail = res.data.email;
        this.empPhone = res.data.phone;
        this.rmName = res.data.rm_name;
        this.rmUserId = res.data.rm_user_id;
        this.ccId = res.data.cc_id;
        this.empImage = res.data.emp_img;
        this.empStatus = res.data.status;
      } else {
      }
    });
  }

  openAppSlide(): void {
    $('.appList').toggleClass('xyz1');
  }
  applicationBack1(): void {
    $('.appList').removeClass('xyz1');
  }

  goToApplication(appLink, apps): void {
    console.log('origin', document.location.origin);
    console.log('apps', apps);
    if (apps.portal_url == document.location.origin) {
      this.menus$ = this.store.pipe(select(AppMenu, { path: appLink }));
      let isLoad = 0;
      this.menus$.subscribe((res) => {
        if (res.length === 0) {
          isLoad = 1;
        }
      });
      this.spinner.show();
      this.applicationBack1();
      this.store.dispatch(isQuickLinks({ status: false }));

      this.router.navigate(['/' + appLink]);

      if (isLoad === 1) {
        this.store.dispatch(LoadRoleMenus({ path: appLink }));
      }
      setTimeout(() => {
        this.spinner.hide();
      }, 3000);
    } else {
      this.authService.appLogin(appLink).subscribe(
        (res) => {
          console.log(apps.portal_url + '/#/auth/app-login/' + res.data);
          let route = environment.routing;
          let ren = environment.routingEnable;
          if (ren) {
            window.open(
              apps.portal_url + '/#/auth/app-login/' + res.data,
              '_self'
            );
          } else {
            window.open(route + '/#/auth/app-login/' + res.data, '_self');
          }
        },
        (err) => {
          this.notifyService.showError('Something Went Wrong');
        }
      );
    }
  }

  openQueryModal(id): void {
    console.log(id);
    $(id).modal({ backdrop: 'static', keyboard: false });
  }

  // sos

  get sosErrorMsg(): any {
    return this.sosForm.controls;
  }

  sosDisk(): void {
    $('#sos-help-disk').modal('show');
  }

  submitSos(): void {
    this.submit = true;
    if (this.sosForm.invalid) {
      return;
    } else {
      const sosForm = new FormData();
      sosForm.append(
        'sos_contact_no',
        this.sosForm.get('sos_contact_no').value
      );
      this.kudosServe.sosService(sosForm).subscribe(
        (res) => {
          this.submit = false;
          if (res.status) {
            this.reset();
            this.notifyService.showSuccess(res.msg, 'Success!');
            $('#sos-help-disk').modal('hide');
          } else {
            this.notifyService.showInfo(res.msg, 'Info!');
          }
        },
        (err) => {
          this.submit = false;
          this.notifyService.showError('Internal Server Error', 'Error!');
        }
      );
    }
  }

  showApprovals(): void {
    this.sideSrv.showApprovalsDialog();
  }

  reset(): void {
    this.submit = false;
    this.sosForm.reset();
  }

  stpHngr():void {
    this.router.navigate(['/stop-hunger']);
  }

  goToVMS(): void {
      let userData= {
        name: this.empName,
        email: this.empEmail,
        phone: this.empPhone,
        mapped_pc_id: [],
        level1: [
          {rm_id: this.rmUserId, rm_email: 'kamal.sharma@mobilise.co.in', rm_desination: 'CFO', rm_name: this.rmName}
        ]
      };
    // console.log('https://atithi.onmobilise.com/integration/mobilise-sparsh?' + 'userData=' + JSON.stringify(userData) + '&jwt_secret=rftUaCLPdwXTeCeI_nqmCG0F6wIUP5CHhrffOYGr5vMaHnJrU9wgGCc_ALRrBP1o');
    window.open("https://atithi.onmobilise.com/integration/mobilise-sparsh?" + 'userData=' + JSON.stringify(userData) + '&jwt_secret=rftUaCLPdwXTeCeI_nqmCG0F6wIUP5CHhrffOYGr5vMaHnJrU9wgGCc_ALRrBP1o', '_self');
  }
}
